import {RouteComponentProps} from 'react-router-dom';
import Box from '@amzn/awsui-components-react/polaris/box';
import React, {useEffect, useState} from 'react';
import {RuleGroup, RuleGroupName} from '../../../backend/model';
import AjaxStatusIndicator from '../../basic/AjaxStatusIndicator';
import { parseErrorMessage } from '../../../utils/errors';
import RuleGroupsTable from './RuleGroupsTable';
import RuleGroupDetailsPanel from './RuleGroupDetailsPanel';
import { Breadcrumbs } from '../../navigation/breadcrumb';
import {getRuleGroupPageUrl} from '../../../backend/internalUrls';
import {fetchRuleGroupDetails, fetchRuleGroups} from '../../../backend/backend';
import { BreadcrumbGroupProps } from '@amzn/awsui-components-react';

type RuleGroupsPageProps = RouteComponentProps<{
    ruleGroupName?: string,
    ruleName?: string,
}>

const RuleGroupsPage: React.FC<RuleGroupsPageProps> = (props) => {
    const [ruleGroups, setRuleGroups] = useState<RuleGroupName[]>()
    const [ruleGroup, setRuleGroup] = useState<RuleGroup>()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessages, setErrorMessages] = useState<string[]>([])

    const [childRuleGroups, setChildRuleGroups] = useState<string[]>()
    const [inheritedRuleGroups, setInheritedRuleGroups] = useState<RuleGroup[]>()

    const ruleGroupNameFromUrl = (props.match.params.ruleGroupName as string)?.trim() || ''
    const ruleNameFromUrl = (props.match.params.ruleName as string)?.trim() || ''

    let breadcrumbItems: BreadcrumbGroupProps.Item[] = [{text: 'Rule Groups', href: getRuleGroupPageUrl()}]
    if (ruleGroupNameFromUrl != '') {
        breadcrumbItems.push({text: ruleGroupNameFromUrl, href: getRuleGroupPageUrl(ruleGroupNameFromUrl)})
        if (ruleNameFromUrl != '') {
            breadcrumbItems.push({text: ruleNameFromUrl, href: getRuleGroupPageUrl(ruleGroupNameFromUrl, ruleNameFromUrl)})
        }
    }

    const resetState = (): void => {
        setRuleGroups(undefined)
        setRuleGroup(undefined)
        setInheritedRuleGroups(undefined)
        setChildRuleGroups(undefined)
        setErrorMessages([])
    }

    useEffect(() => {
        getRuleGroups(ruleGroupNameFromUrl)
    }, [ruleGroupNameFromUrl])

    const getRuleGroups = async (ruleGroupName: string) => {
        resetState()

        setIsLoading(true)
        if (ruleGroupName) {
            await fetchRuleGroupByName(ruleGroupName)
        } else {
            setRuleGroups((await fetchRuleGroups()).data.ruleGroupNames.map((item: string): RuleGroupName => ({
                name: item
            })))
        }
        setIsLoading(false)
    }

    async function fetchRuleGroupByName(ruleGroupName: string) {
        try {
            const checkRuleGroupResponse = (await fetchRuleGroupDetails(ruleGroupName)).data
            setRuleGroup(checkRuleGroupResponse.ruleGroup)
            setInheritedRuleGroups(checkRuleGroupResponse.inheritedRuleGroups)
            setChildRuleGroups(checkRuleGroupResponse.childRuleGroups)
        } catch (error: any) {
            console.error(error)
            setErrorMessages([parseErrorMessage(error)])
            setRuleGroup(undefined)
            setInheritedRuleGroups(undefined)
            setChildRuleGroups(undefined)
        }
    }

    return <div id='rule-groups'>
        <Box variant="h1">{(ruleNameFromUrl != '') ? "Rule Details" : "Rule Groups"}</Box>
        <br/>
        <Breadcrumbs items={breadcrumbItems}/>
        <AjaxStatusIndicator errorMessage={errorMessages.join(' ')} loading={isLoading}/>
        <br/>
        {ruleGroup && childRuleGroups && inheritedRuleGroups && <RuleGroupDetailsPanel {...props} childRuleGroups={childRuleGroups} inheritedRuleGroups={inheritedRuleGroups} ruleGroup={ruleGroup} ruleName={ruleNameFromUrl}/>}
        {ruleGroups && <RuleGroupsTable tableItems={ruleGroups ?? []} fileName='DNC Rule Groups'/>}
    </div>
}

export default RuleGroupsPage
